export { DataSetSnapshot as default } from 'choerodon-ui/dataset';
